<template>
  <div>
    <v-parallax
      height="360"
      src="https://xuanyuanjiang.oss-cn-beijing.aliyuncs.com/f-351e40c1-d7e2-468a-88db-b44a7f376894"
    ></v-parallax>
    <v-container class="px-lg-12" style="top:-136px;position:relative">
      <v-row class=" px-lg-16">
        <v-col md="12" xs="12" class="">
          <v-card class="mx-auto my-4 px-3   py-6" min-height="500">
            <v-progress-linear
              v-if="loading"
              indeterminate
              color="yellow darken-2"
            ></v-progress-linear>
            <v-breadcrumbs
              v-else
              :items="categoryItems"
              divider="-"
              class="pb-1 pl-4"
            ></v-breadcrumbs>
            <v-card-title class="pt-2">
              <div class="text-h4 font-weight-bold">{{ payload.title }}</div>
            </v-card-title>

            <v-card-subtitle class="grey--text text--darken-4">
              <div
                class="d-flex mt-8 mb-0 justify-start grey--text text--darken-1"
              >
                <div class="mr-8 text-subtitle-2 ">
                  发布时间:{{ payload.publicAt | time }}
                </div>
                <div class="mr-8 text-subtitle-2" v-if="payload.author">
                  作者:{{ payload.author }}
                </div>
              </div>
            </v-card-subtitle>
            <v-card-text>
              <div
                class="text-body-1 grey--text text--darken-4"
                v-html="payload.content"
              ></div
            ></v-card-text>
          </v-card>
        </v-col>
        <!-- <v-col md="3" xs="12">
        <v-card class="mx-auto my-4">
          <v-img height="250" :src="require('../../assets/2.jpg')" />

          <v-divider class="mx-4"></v-divider>
        </v-card>
      </v-col> -->
      </v-row>
    </v-container>
  </div>
</template>

<script>
import config from "../../config/index";
import moment from "moment";

import { subNode, getNode, getNodeById } from "../../api.js";
export default {
  props: ["id"],
  data: () => ({
    articles: [],
    loading: true,
    categoryItems: [
      // {
      //   text: "文章",
      //   disabled: false,
      //   href: "breadcrumbs_dashboard",
      // },
      // {
      //   text: "北丐观点",
      //   disabled: false,
      //   href: "breadcrumbs_link_1",
      // },
    ],
    active: [],
    open: [],
    records: [],
    category: [],
    content: {},
    node: {},
    payload: {},
  }),
  methods: {
    async getArticle() {
      this.loading = true;

      const res = await getNodeById({
        frameId: config.frameId,
        id: this.id,
      });
      this.loading = false;

      this.content = res.data.data;
      this.payload = res.data.data.node.payload;
      const coordinate = this.content.position.coordinate;
      this.categoryItems = [];
      for (let i = 0, l = coordinate.length - 3; i < l; i++) {
        coordinate.pop();
        console.log("curCoordinate", coordinate);

        let resSub = await getNode({
          position: {
            frameId: this.content.position.frameId,
            coordinate: coordinate,
          },
        });

        let category = resSub.data.data;
        this.categoryItems.unshift({
          text: category.node.payload.title,
          disabled: false,
          href: "breadcrumbs_dashboard",
        });
      }
    },
    getCategory(position) {
      subNode({
        position: position,
        query: {
          variety: "category",
        },
        depth: 1,
      });
    },
  },
  computed: {},
  watch: {
    id: async function() {
      await this.getArticle();
    },
  },
  filters: {
    time(value) {
      return moment(value).format("YYYY-M-D ");
    },
  },
  async mounted() {
    await this.getArticle();
  },
};
</script>
<style lang="scss" scoped>
.article {
  margin-bottom: 16px;
}
img {
  max-width: 100%;
}
</style>
